<template>
    <div class="responses">
        <div class="responses__body">
            <div class="list-wrapper">
                <ul class="d-flex flex-column todo-list todo-list-custom">

                    <!--<li v-for="(utr, index) in filteredUtterance  " >-->
                    <li :key="index" class="response__block" v-for="(response, index) in getResponses  ">
                        <div class="ord">{{index+1}}.</div>
                        <div class="response_label">
                            {{response.type === "text" ? "Text Response" : "Quick Reply"}}
                        </div>
                        <input
                                class="response__input"
                                type="text"
                                name=""
                                :placeholder="response.type === 'text' ? 'Type Text Response' : 'Type Quick Reply'"
                                :id="index"
                                v-on:focus="onFocus"
                                v-on:change="onUpdate"
                                :value="response.text"
                        />
                        <i :id=index @click="onDelete(index)" class="remove mdi mdi-delete-circle"></i>
                    </li>
                </ul>
            </div>
            <!--<div :key="index" class="response__block" v-for="(response, index) in getResponses  ">-->
                <!--<div class="response__type">-->
                    <!--<span>{{response.type === "text" ? "Text Response" : "Quick Reply"}}</span>-->
                    <!--<span :id=index @click="onDelete(index)" class="response__delete">&#128465;</span>-->
                <!--</div>-->
                <!--<ol class="response__list">-->
                    <!--<li class="response__item">-->
                        <!--<span class="response__number">{{index + 1}}</span>-->
                        <!--<input-->
                                <!--class="response__input"-->
                                <!--type="text"-->
                                <!--name=""-->
                                <!--:id="index"-->
                                <!--v-on:change="onUpdate"-->
                                <!--:value="response.text"-->
                        <!--/>-->
                    <!--</li>-->
                <!--</ol>-->

            <!--</div>-->


            <div v-if="!getResponses.length>0" class="response__block">
                <div class="response__type">No response</div>
            </div>

        </div>
        <div class="response__add">
            <button @click="onCreate(text)" value="text" class="btn btn btn-sm btn-success">
                Add Text Response
            </button>
            <button @click="onCreate(quick_replies)" value="quick_replies" class="btn btn-sm btn-success">
                Add Quick Response
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "responses",
        props: ['responses'],
        data() {
            return {
                text: "text",
                quick_replies: "quick_replies",
                factory:[],
            }
        },
        computed: {
            getResponses() {
                return this.responses ? this.responses : [];
            }
        },
        methods: {
            onDelete(index) {
                this.$emit("onDelete",index)
            },
            onCreate(type) {
                this.$emit("onCreate",type)
            },
            onUpdate(event) {
                this.$emit("onUpdate",event)
            },
            onFocus(event){
               // console.log(event.target.value);
                this.$emit("onFocus",event.target.value)
            }
        }
    }
</script>

<style scoped>
    .response__add{
       display: flex;
        justify-content: flex-start;
    }
    .response__add .btn{
        margin-left: 10px;
    }
    .response_label{
        display: block;
    }
   .response__input {
       width: 100%;
        padding: 12px 10px;
        outline: medium;
        font-size: 1em;
       color: #000000;
       background: #f6f6f6;
       border: none;
    }
   .response__block{
       position: relative;
       margin-bottom: 20px;
   }
    .response__block .response_label{
        position: absolute;
        top: -10px;
    }
    .list-wrapper .remove{
        top: -10px!important;
        position: absolute;
        right: 5px;
    }
    .response__add{
        margin-top: 20px;
    }
    .list-wrapper ul {
        padding: 0;
        text-align: left;
        list-style: none;
        margin-bottom: 0;
    }
    .list-wrapper li {
        font-size: .9375rem;
        padding: .7rem 0;
        line-height: normal;
        border-bottom: 1px solid #ebedf2;
    }
   .list-wrapper ul li, {
        -webkit-box-align: center !important;
        -ms-flex-align: center !important;
        align-items: center !important;
    }

  .list-wrapper ul li {
        -webkit-box-pack: start !important;
        -ms-flex-pack: start !important;
        justify-content: flex-start !important;
    }

    .d-flex, .list-wrapper ul li {
        display: -webkit-box !important;
        display: -ms-flexbox !important;
        display: flex !important;
    }

    .list-wrapper .remove {
        cursor: pointer;
        font-size: 1.438rem;
        font-weight: 600;
        width: 1.25rem;
        height: 1.25rem;
        line-height: 20px;
        text-align: center;
    }

    .holder {
        box-sizing: border-box;
        padding: 0 20px;
        /*margin-top: 20px;*/
    }

    .list-wrapper .remove:hover {
        color: red !important;
    }

   .list-wrapper .remove {
        color: #c3bdbd !important;
    }

   .list-wrapper .remove, {
        margin-left: auto !important;
    }

    .ord {
        margin-right: 10px;
    }
</style>
